// Description: This screen will show all inventory items that are low in stock

import React, { useContext, useEffect } from 'react'
import { Container, Table, Row, Col, Button } from 'react-bootstrap'
import LowInventoryUnit from '../components/LowInventoryUnit'
import { getLowInventory } from '../actions/reportActions'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Loader from '../components/Loader'
import Message from '../components/Message'
import PaginateLow from '../components/Paginate'
import { ThemeContext } from '../components/ThemeContext.js'
import {
  EMPLOYEE_PERMISSIONS,
  hasEmployeePermission
} from '../constants/employeePermissions.js'

const LowInventory = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { theme } = useContext(ThemeContext)

  const { lowpageNumber } = useParams() || 1

  const lowInventory = useSelector((state) => state.lowInventory)
  const { loading, error, lowinventory, lowpage, lowpages, lowcount } =
    lowInventory

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const canViewReports = hasEmployeePermission(
    userInfo,
    ownerInfo,
    EMPLOYEE_PERMISSIONS.REPORTS_VIEW
  )

  // Sort the array by manufacturer
  lowinventory.sort((a, b) => (a.manufacturer > b.manufacturer ? 1 : -1))

  // Remove duplicate items from the array
  const uniqueObjects = [
    ...new Map(lowinventory.map((element) => [element._id, element])).values()
  ]

  // Use effect for pagenumber change
  useEffect(() => {
    if (!userInfo && !ownerInfo) {
      dispatch({ type: 'LOW_INVENTORY_RESET' })
      navigate('/login')
    } else if (!canViewReports) {
      navigate('/pos')
    } else {
      dispatch(getLowInventory(lowpageNumber))
    }
  }, [dispatch, navigate, lowpageNumber, userInfo, ownerInfo, canViewReports])

  return (
    <Container className='my-3' style={{ color: theme.text }}>
      <PaginateLow pages={lowpages} page={lowpage} />
      <Row className='align-items-center'>
        <Col>
          <h3>Low Inventory by Manufacturer</h3>
        </Col>
        <Col className='text-right'>
          <Button
            size='sm'
            className='my-3'
            variant='outline-primary'
            onClick={() => window.print()}
          >
            Print Report
          </Button>
        </Col>
        <Col className='text-right'>
          <Button
            size='sm'
            variant='outline-primary'
            className='my-3'
            onClick={() => navigate('/reports')}
          >
            Go Back
          </Button>
        </Col>
      </Row>

      {lowcount === 0 && <Message variant='info'>None Found</Message>}
      {loading ?
        <Loader />
      : error ?
        <Message variant='danger'>{error}</Message>
      : <Table striped bordered hover responsive className='table-sm'>
          <thead>
            <tr>
              <th>UPC</th>
              <th>Item</th>
              <th>Manufacturer</th>
              <th>Subname</th>
              <th>Qty</th>
              <th>Low</th>
              <th>Price</th>
              <th>Last Update</th>
              <th>UPD</th>
            </tr>
          </thead>
          <tbody>
            {uniqueObjects.map((unit) => (
              <LowInventoryUnit key={unit._id} unit={unit} />
            ))}
          </tbody>
        </Table>
      }
    </Container>
  )
}

export default LowInventory
